// DealsSection.js - Estatica Skin and Laser
import React, { useState, useEffect, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { Container, Row, Col } from "react-bootstrap";
import axios from "axios";
import AppContext from "../../../context/AppContext";
import "../../../assets/css/customer/screens/deals/DealsSection.css";
import EsDealCard from "../../../components/customer/deals/EsDealCard";
const DealsSection = ({screen}) => {
  const navigate = useNavigate();
  const { baseUrl } = useContext(AppContext);

  const [deals, setDeals] = useState([]);

useEffect(() => {
  axios
    .get(`${baseUrl}/admin/deals/viewAllDeals`)
    .then((response) => {
      setDeals(response.data);

      if (screen === "deal") {
        setDeals(response.data.slice(0, 4));
      } else {
        setDeals(response.data);
      }
    })
    .catch((err) => console.log(err));
}, []);

  return (
    <section className="estatica-deals">
      <Container>
        {/* Heading */}
        <Row>
          <Col lg={7} md={10}>
            <p className="estatica-deals__label">Limited Time</p>
            <h2 className="estatica-deals__heading">Skin &amp; laser deals.</h2>
            <p className="estatica-deals__subtext">
              Hand-picked offers refreshed each season. Available while slots
              last.
            </p>
          </Col>
        </Row>

        {/* Cards Grid */}
        <Row className="g-4">
          {deals.map((deal) => (
            <EsDealCard deal={deal}/>
            // <Col lg={6} md={6} sm={12} key={deal.id}>
            //   <div className="estatica-deals__card">
            //     {/* Badge */}
            //     {deal.tag && (
            //       <span className="estatica-deals__badge">{deal.tag}</span>
            //     )}

            //     {/* Discount */}
            //     <p className="estatica-deals__discount">{deal.discount}</p>

            //     {/* Name & Desc */}
            //     <h4 className="estatica-deals__name">{deal.title}</h4>
            //     <p className="estatica-deals__desc">{deal.description}</p>

            //     {/* Buttons */}
            //     <div className="estatica-deals__btn-group">
            //       <button className="estatica-deals__btn-claim">
            //         Claim this deal
            //       </button>
            //       <button
            //         className="estatica-deals__btn-view"
            //         onClick={() => navigate(`/deals/${deal.id}`)}
            //         // Jahan "View Details" button hai wahan yeh karo

            //       >
            //         View details
            //       </button>
            //     </div>
            //   </div>
            // </Col>
          ))}
        </Row>
      </Container>
    </section>
  );
};

export default DealsSection;